/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import { Inject, Injectable, Optional } from '@angular/core';
import {
  GrpcCallType,
  GrpcClient,
  GrpcClientFactory,
  GrpcEvent,
  GrpcMetadata
} from '@ngx-grpc/common';
import {
  GRPC_CLIENT_FACTORY,
  GrpcHandler,
  takeMessages,
  throwStatusErrors
} from '@ngx-grpc/core';
import { Observable } from 'rxjs';
import * as thisProto from './admin.pb';
import * as googleProtobuf000 from '@ngx-grpc/well-known-types';
import * as googleProtobuf001 from '@ngx-grpc/well-known-types';
import * as googleProtobuf002 from '@ngx-grpc/well-known-types';
import {
  GRPC_IDENTITY_ENDPOINT_CLIENT_SETTINGS,
  GRPC_CUSTOMER_ASSETS_ENDPOINT_CLIENT_SETTINGS,
  GRPC_LOGGER_ENDPOINT_CLIENT_SETTINGS,
  GRPC_SUBSCRIPTION_ENDPOINT_CLIENT_SETTINGS,
  GRPC_SMART_CHARGE_ENDPOINT_CLIENT_SETTINGS,
  GRPC_ADMIN_POWER_PRICE_ENDPOINT_CLIENT_SETTINGS,
  GRPC_REPORT_SERVICE_ENDPOINT_CLIENT_SETTINGS
} from './admin.pbconf';
/**
 * Service client implementation for epicore.admin.IdentityEndpoint
 */
@Injectable({ providedIn: 'any' })
export class IdentityEndpointClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/Register
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.RegisterResponse>>
     */
    register: (
      requestData: thisProto.RegisterRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.RegisterResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/Register',
        requestData,
        requestMetadata,
        requestClass: thisProto.RegisterRequest,
        responseClass: thisProto.RegisterResponse
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/Login
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.LoginResponse>>
     */
    login: (
      requestData: thisProto.LoginRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.LoginResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/Login',
        requestData,
        requestMetadata,
        requestClass: thisProto.LoginRequest,
        responseClass: thisProto.LoginResponse
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/Update
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<googleProtobuf000.Empty>>
     */
    update: (
      requestData: thisProto.UpdateUserRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<googleProtobuf000.Empty>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/Update',
        requestData,
        requestMetadata,
        requestClass: thisProto.UpdateUserRequest,
        responseClass: googleProtobuf000.Empty
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/UsersList
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.UsersListResponse>>
     */
    usersList: (
      requestData: thisProto.UsersListRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.UsersListResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/UsersList',
        requestData,
        requestMetadata,
        requestClass: thisProto.UsersListRequest,
        responseClass: thisProto.UsersListResponse
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/GetUser
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetUserResponse>>
     */
    getUser: (
      requestData: thisProto.GetUserRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetUserResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/GetUser',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetUserRequest,
        responseClass: thisProto.GetUserResponse
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/GetCurrentUserInfo
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetUserResponse>>
     */
    getCurrentUserInfo: (
      requestData: googleProtobuf000.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetUserResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/GetCurrentUserInfo',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf000.Empty,
        responseClass: thisProto.GetUserResponse
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/Disable
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<googleProtobuf000.Empty>>
     */
    disable: (
      requestData: thisProto.GetUserRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<googleProtobuf000.Empty>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/Disable',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetUserRequest,
        responseClass: googleProtobuf000.Empty
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/Enable
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<googleProtobuf000.Empty>>
     */
    enable: (
      requestData: thisProto.GetUserRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<googleProtobuf000.Empty>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/Enable',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetUserRequest,
        responseClass: googleProtobuf000.Empty
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/ResetPassword
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<googleProtobuf000.Empty>>
     */
    resetPassword: (
      requestData: thisProto.ResetPasswordRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<googleProtobuf000.Empty>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/ResetPassword',
        requestData,
        requestMetadata,
        requestClass: thisProto.ResetPasswordRequest,
        responseClass: googleProtobuf000.Empty
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/GetAllRoles
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.UserRolesResponse>>
     */
    getAllRoles: (
      requestData: googleProtobuf000.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.UserRolesResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/GetAllRoles',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf000.Empty,
        responseClass: thisProto.UserRolesResponse
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/CreateRole
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.RoleDtoResult>>
     */
    createRole: (
      requestData: thisProto.CreateRoleRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.RoleDtoResult>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/CreateRole',
        requestData,
        requestMetadata,
        requestClass: thisProto.CreateRoleRequest,
        responseClass: thisProto.RoleDtoResult
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/UpdateRole
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.RoleDtoResult>>
     */
    updateRole: (
      requestData: thisProto.UpdateRoleRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.RoleDtoResult>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/UpdateRole',
        requestData,
        requestMetadata,
        requestClass: thisProto.UpdateRoleRequest,
        responseClass: thisProto.RoleDtoResult
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/DisableRole
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<googleProtobuf000.Empty>>
     */
    disableRole: (
      requestData: thisProto.DisableRoleRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<googleProtobuf000.Empty>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/DisableRole',
        requestData,
        requestMetadata,
        requestClass: thisProto.DisableRoleRequest,
        responseClass: googleProtobuf000.Empty
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/GetAllGroups
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.UserGroupsResponse>>
     */
    getAllGroups: (
      requestData: googleProtobuf000.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.UserGroupsResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/GetAllGroups',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf000.Empty,
        responseClass: thisProto.UserGroupsResponse
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/CreateGroup
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.UserGroupDto>>
     */
    createGroup: (
      requestData: thisProto.CreateGroupRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.UserGroupDto>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/CreateGroup',
        requestData,
        requestMetadata,
        requestClass: thisProto.CreateGroupRequest,
        responseClass: thisProto.UserGroupDto
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/UpdateGroup
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<googleProtobuf000.Empty>>
     */
    updateGroup: (
      requestData: thisProto.UpdateGroupRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<googleProtobuf000.Empty>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/UpdateGroup',
        requestData,
        requestMetadata,
        requestClass: thisProto.UpdateGroupRequest,
        responseClass: googleProtobuf000.Empty
      });
    },
    /**
     * Unary call: /epicore.admin.IdentityEndpoint/ChangeDisableStatusGroup
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<googleProtobuf000.Empty>>
     */
    changeDisableStatusGroup: (
      requestData: thisProto.DisableGroupStatusRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<googleProtobuf000.Empty>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.IdentityEndpoint/ChangeDisableStatusGroup',
        requestData,
        requestMetadata,
        requestClass: thisProto.DisableGroupStatusRequest,
        responseClass: googleProtobuf000.Empty
      });
    }
  };

  constructor(
    @Optional() @Inject(GRPC_IDENTITY_ENDPOINT_CLIENT_SETTINGS) settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'epicore.admin.IdentityEndpoint',
      settings
    );
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/Register
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.RegisterResponse>
   */
  register(
    requestData: thisProto.RegisterRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.RegisterResponse> {
    return this.$raw
      .register(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/Login
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.LoginResponse>
   */
  login(
    requestData: thisProto.LoginRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.LoginResponse> {
    return this.$raw
      .login(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/Update
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<googleProtobuf000.Empty>
   */
  update(
    requestData: thisProto.UpdateUserRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<googleProtobuf000.Empty> {
    return this.$raw
      .update(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/UsersList
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.UsersListResponse>
   */
  usersList(
    requestData: thisProto.UsersListRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.UsersListResponse> {
    return this.$raw
      .usersList(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/GetUser
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetUserResponse>
   */
  getUser(
    requestData: thisProto.GetUserRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetUserResponse> {
    return this.$raw
      .getUser(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/GetCurrentUserInfo
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetUserResponse>
   */
  getCurrentUserInfo(
    requestData: googleProtobuf000.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetUserResponse> {
    return this.$raw
      .getCurrentUserInfo(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/Disable
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<googleProtobuf000.Empty>
   */
  disable(
    requestData: thisProto.GetUserRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<googleProtobuf000.Empty> {
    return this.$raw
      .disable(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/Enable
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<googleProtobuf000.Empty>
   */
  enable(
    requestData: thisProto.GetUserRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<googleProtobuf000.Empty> {
    return this.$raw
      .enable(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/ResetPassword
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<googleProtobuf000.Empty>
   */
  resetPassword(
    requestData: thisProto.ResetPasswordRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<googleProtobuf000.Empty> {
    return this.$raw
      .resetPassword(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/GetAllRoles
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.UserRolesResponse>
   */
  getAllRoles(
    requestData: googleProtobuf000.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.UserRolesResponse> {
    return this.$raw
      .getAllRoles(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/CreateRole
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.RoleDtoResult>
   */
  createRole(
    requestData: thisProto.CreateRoleRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.RoleDtoResult> {
    return this.$raw
      .createRole(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/UpdateRole
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.RoleDtoResult>
   */
  updateRole(
    requestData: thisProto.UpdateRoleRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.RoleDtoResult> {
    return this.$raw
      .updateRole(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/DisableRole
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<googleProtobuf000.Empty>
   */
  disableRole(
    requestData: thisProto.DisableRoleRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<googleProtobuf000.Empty> {
    return this.$raw
      .disableRole(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/GetAllGroups
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.UserGroupsResponse>
   */
  getAllGroups(
    requestData: googleProtobuf000.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.UserGroupsResponse> {
    return this.$raw
      .getAllGroups(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/CreateGroup
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.UserGroupDto>
   */
  createGroup(
    requestData: thisProto.CreateGroupRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.UserGroupDto> {
    return this.$raw
      .createGroup(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/UpdateGroup
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<googleProtobuf000.Empty>
   */
  updateGroup(
    requestData: thisProto.UpdateGroupRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<googleProtobuf000.Empty> {
    return this.$raw
      .updateGroup(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.IdentityEndpoint/ChangeDisableStatusGroup
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<googleProtobuf000.Empty>
   */
  changeDisableStatusGroup(
    requestData: thisProto.DisableGroupStatusRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<googleProtobuf000.Empty> {
    return this.$raw
      .changeDisableStatusGroup(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
/**
 * Service client implementation for epicore.admin.CustomerAssetsEndpoint
 */
@Injectable({ providedIn: 'any' })
export class CustomerAssetsEndpointClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/AddNewPlant
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.PlantResponse>>
     */
    addNewPlant: (
      requestData: thisProto.NewPlantRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.PlantResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/AddNewPlant',
        requestData,
        requestMetadata,
        requestClass: thisProto.NewPlantRequest,
        responseClass: thisProto.PlantResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/UpdatePlant
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.PlantResponse>>
     */
    updatePlant: (
      requestData: thisProto.UpdatePlantRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.PlantResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/UpdatePlant',
        requestData,
        requestMetadata,
        requestClass: thisProto.UpdatePlantRequest,
        responseClass: thisProto.PlantResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/ToggleDisablePlant
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.ToggleDisablePlantResponse>>
     */
    toggleDisablePlant: (
      requestData: thisProto.ToggleDisablePlantRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.ToggleDisablePlantResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/ToggleDisablePlant',
        requestData,
        requestMetadata,
        requestClass: thisProto.ToggleDisablePlantRequest,
        responseClass: thisProto.ToggleDisablePlantResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/GetPlants
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.PlantsResponse>>
     */
    getPlants: (
      requestData: thisProto.GetPlantsRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.PlantsResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/GetPlants',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetPlantsRequest,
        responseClass: thisProto.PlantsResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/GetPlantFullDetail
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.PlantFullDetailResponse>>
     */
    getPlantFullDetail: (
      requestData: thisProto.GePlantFullDetailByIdRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.PlantFullDetailResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/GetPlantFullDetail',
        requestData,
        requestMetadata,
        requestClass: thisProto.GePlantFullDetailByIdRequest,
        responseClass: thisProto.PlantFullDetailResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/GetPlantFullDetailByUserId
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.PlantFullDetailListResponse>>
     */
    getPlantFullDetailByUserId: (
      requestData: thisProto.GetPlantFullDetailByUserIdRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.PlantFullDetailListResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/epicore.admin.CustomerAssetsEndpoint/GetPlantFullDetailByUserId',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetPlantFullDetailByUserIdRequest,
        responseClass: thisProto.PlantFullDetailListResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/GetAddPlantPrerequisites
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetAddPlantPrerequisitesResponse>>
     */
    getAddPlantPrerequisites: (
      requestData: googleProtobuf000.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetAddPlantPrerequisitesResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/GetAddPlantPrerequisites',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf000.Empty,
        responseClass: thisProto.GetAddPlantPrerequisitesResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/AddPlantInverter
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.PlantInvertersInfo>>
     */
    addPlantInverter: (
      requestData: thisProto.AddPlantInverterRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.PlantInvertersInfo>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/AddPlantInverter',
        requestData,
        requestMetadata,
        requestClass: thisProto.AddPlantInverterRequest,
        responseClass: thisProto.PlantInvertersInfo
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/UpdatePlantInverter
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.PlantInvertersInfo>>
     */
    updatePlantInverter: (
      requestData: thisProto.UpdatePlantInverterRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.PlantInvertersInfo>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/UpdatePlantInverter',
        requestData,
        requestMetadata,
        requestClass: thisProto.UpdatePlantInverterRequest,
        responseClass: thisProto.PlantInvertersInfo
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/ToggleDisableInverter
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.ToggleDisableInverterResponse>>
     */
    toggleDisableInverter: (
      requestData: thisProto.ToggleDisableInverterRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.ToggleDisableInverterResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/ToggleDisableInverter',
        requestData,
        requestMetadata,
        requestClass: thisProto.ToggleDisableInverterRequest,
        responseClass: thisProto.ToggleDisableInverterResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/GetAddInverterPrerequisites
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetPrerequisitesResponse>>
     */
    getAddInverterPrerequisites: (
      requestData: googleProtobuf000.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetPrerequisitesResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/epicore.admin.CustomerAssetsEndpoint/GetAddInverterPrerequisites',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf000.Empty,
        responseClass: thisProto.GetPrerequisitesResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/AddNewCity
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.CityResponse>>
     */
    addNewCity: (
      requestData: thisProto.NewCityRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.CityResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/AddNewCity',
        requestData,
        requestMetadata,
        requestClass: thisProto.NewCityRequest,
        responseClass: thisProto.CityResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/UpdateCity
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.CityResponse>>
     */
    updateCity: (
      requestData: thisProto.UpdateCityRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.CityResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/UpdateCity',
        requestData,
        requestMetadata,
        requestClass: thisProto.UpdateCityRequest,
        responseClass: thisProto.CityResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/ToggleDisableCity
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.ToggleDisableCityResponse>>
     */
    toggleDisableCity: (
      requestData: thisProto.ToggleDisableCityRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.ToggleDisableCityResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/ToggleDisableCity',
        requestData,
        requestMetadata,
        requestClass: thisProto.ToggleDisableCityRequest,
        responseClass: thisProto.ToggleDisableCityResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/GetCities
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.CitiesResponse>>
     */
    getCities: (
      requestData: thisProto.GetCitiesRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.CitiesResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/GetCities',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetCitiesRequest,
        responseClass: thisProto.CitiesResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/GetTimeZones
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.TimeZonesResponse>>
     */
    getTimeZones: (
      requestData: googleProtobuf000.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.TimeZonesResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/GetTimeZones',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf000.Empty,
        responseClass: thisProto.TimeZonesResponse
      });
    },
    /**
     * Client streaming: /epicore.admin.CustomerAssetsEndpoint/UploadPlantImage
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.UploadPlantImageResponse>>
     */
    uploadPlantImage: (
      requestData: Observable<thisProto.UploadPlantImageRequest>,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.UploadPlantImageResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.clientStream,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/UploadPlantImage',
        requestData,
        requestMetadata,
        requestClass: thisProto.UploadPlantImageRequest,
        responseClass: thisProto.UploadPlantImageResponse
      });
    },
    /**
     * Server streaming: /epicore.admin.CustomerAssetsEndpoint/GetPlantImage
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetPlantImageResponse>>
     */
    getPlantImage: (
      requestData: thisProto.GetPlantImageRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetPlantImageResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.serverStream,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/GetPlantImage',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetPlantImageRequest,
        responseClass: thisProto.GetPlantImageResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/GetPlantImageUrl
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetPlantImageUrlResponse>>
     */
    getPlantImageUrl: (
      requestData: thisProto.GetPlantImageRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetPlantImageUrlResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/GetPlantImageUrl',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetPlantImageRequest,
        responseClass: thisProto.GetPlantImageUrlResponse
      });
    },
    /**
     * Unary call: /epicore.admin.CustomerAssetsEndpoint/GetB2BPlants
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetB2BPlantsResponse>>
     */
    getB2BPlants: (
      requestData: googleProtobuf000.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetB2BPlantsResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.CustomerAssetsEndpoint/GetB2BPlants',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf000.Empty,
        responseClass: thisProto.GetB2BPlantsResponse
      });
    }
  };

  constructor(
    @Optional()
    @Inject(GRPC_CUSTOMER_ASSETS_ENDPOINT_CLIENT_SETTINGS)
    settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'epicore.admin.CustomerAssetsEndpoint',
      settings
    );
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/AddNewPlant
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.PlantResponse>
   */
  addNewPlant(
    requestData: thisProto.NewPlantRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.PlantResponse> {
    return this.$raw
      .addNewPlant(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/UpdatePlant
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.PlantResponse>
   */
  updatePlant(
    requestData: thisProto.UpdatePlantRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.PlantResponse> {
    return this.$raw
      .updatePlant(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/ToggleDisablePlant
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.ToggleDisablePlantResponse>
   */
  toggleDisablePlant(
    requestData: thisProto.ToggleDisablePlantRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.ToggleDisablePlantResponse> {
    return this.$raw
      .toggleDisablePlant(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/GetPlants
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.PlantsResponse>
   */
  getPlants(
    requestData: thisProto.GetPlantsRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.PlantsResponse> {
    return this.$raw
      .getPlants(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/GetPlantFullDetail
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.PlantFullDetailResponse>
   */
  getPlantFullDetail(
    requestData: thisProto.GePlantFullDetailByIdRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.PlantFullDetailResponse> {
    return this.$raw
      .getPlantFullDetail(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/GetPlantFullDetailByUserId
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.PlantFullDetailListResponse>
   */
  getPlantFullDetailByUserId(
    requestData: thisProto.GetPlantFullDetailByUserIdRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.PlantFullDetailListResponse> {
    return this.$raw
      .getPlantFullDetailByUserId(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/GetAddPlantPrerequisites
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetAddPlantPrerequisitesResponse>
   */
  getAddPlantPrerequisites(
    requestData: googleProtobuf000.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetAddPlantPrerequisitesResponse> {
    return this.$raw
      .getAddPlantPrerequisites(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/AddPlantInverter
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.PlantInvertersInfo>
   */
  addPlantInverter(
    requestData: thisProto.AddPlantInverterRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.PlantInvertersInfo> {
    return this.$raw
      .addPlantInverter(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/UpdatePlantInverter
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.PlantInvertersInfo>
   */
  updatePlantInverter(
    requestData: thisProto.UpdatePlantInverterRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.PlantInvertersInfo> {
    return this.$raw
      .updatePlantInverter(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/ToggleDisableInverter
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.ToggleDisableInverterResponse>
   */
  toggleDisableInverter(
    requestData: thisProto.ToggleDisableInverterRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.ToggleDisableInverterResponse> {
    return this.$raw
      .toggleDisableInverter(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/GetAddInverterPrerequisites
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetPrerequisitesResponse>
   */
  getAddInverterPrerequisites(
    requestData: googleProtobuf000.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetPrerequisitesResponse> {
    return this.$raw
      .getAddInverterPrerequisites(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/AddNewCity
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.CityResponse>
   */
  addNewCity(
    requestData: thisProto.NewCityRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.CityResponse> {
    return this.$raw
      .addNewCity(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/UpdateCity
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.CityResponse>
   */
  updateCity(
    requestData: thisProto.UpdateCityRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.CityResponse> {
    return this.$raw
      .updateCity(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/ToggleDisableCity
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.ToggleDisableCityResponse>
   */
  toggleDisableCity(
    requestData: thisProto.ToggleDisableCityRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.ToggleDisableCityResponse> {
    return this.$raw
      .toggleDisableCity(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/GetCities
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.CitiesResponse>
   */
  getCities(
    requestData: thisProto.GetCitiesRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.CitiesResponse> {
    return this.$raw
      .getCities(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/GetTimeZones
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.TimeZonesResponse>
   */
  getTimeZones(
    requestData: googleProtobuf000.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.TimeZonesResponse> {
    return this.$raw
      .getTimeZones(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Client streaming @/epicore.admin.CustomerAssetsEndpoint/UploadPlantImage
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.UploadPlantImageResponse>
   */
  uploadPlantImage(
    requestData: Observable<thisProto.UploadPlantImageRequest>,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.UploadPlantImageResponse> {
    return this.$raw
      .uploadPlantImage(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Server streaming @/epicore.admin.CustomerAssetsEndpoint/GetPlantImage
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetPlantImageResponse>
   */
  getPlantImage(
    requestData: thisProto.GetPlantImageRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetPlantImageResponse> {
    return this.$raw
      .getPlantImage(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/GetPlantImageUrl
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetPlantImageUrlResponse>
   */
  getPlantImageUrl(
    requestData: thisProto.GetPlantImageRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetPlantImageUrlResponse> {
    return this.$raw
      .getPlantImageUrl(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.CustomerAssetsEndpoint/GetB2BPlants
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetB2BPlantsResponse>
   */
  getB2BPlants(
    requestData: googleProtobuf000.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetB2BPlantsResponse> {
    return this.$raw
      .getB2BPlants(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
/**
 * Service client implementation for epicore.admin.LoggerEndpoint
 */
@Injectable({ providedIn: 'any' })
export class LoggerEndpointClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /epicore.admin.LoggerEndpoint/GetLogs
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.LogResponseList>>
     */
    getLogs: (
      requestData: thisProto.LogRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.LogResponseList>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.LoggerEndpoint/GetLogs',
        requestData,
        requestMetadata,
        requestClass: thisProto.LogRequest,
        responseClass: thisProto.LogResponseList
      });
    },
    /**
     * Unary call: /epicore.admin.LoggerEndpoint/DeleteOldLogs
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.DeleteLogsResponse>>
     */
    deleteOldLogs: (
      requestData: googleProtobuf000.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.DeleteLogsResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.LoggerEndpoint/DeleteOldLogs',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf000.Empty,
        responseClass: thisProto.DeleteLogsResponse
      });
    }
  };

  constructor(
    @Optional() @Inject(GRPC_LOGGER_ENDPOINT_CLIENT_SETTINGS) settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'epicore.admin.LoggerEndpoint',
      settings
    );
  }

  /**
   * Unary call @/epicore.admin.LoggerEndpoint/GetLogs
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.LogResponseList>
   */
  getLogs(
    requestData: thisProto.LogRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.LogResponseList> {
    return this.$raw
      .getLogs(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.LoggerEndpoint/DeleteOldLogs
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.DeleteLogsResponse>
   */
  deleteOldLogs(
    requestData: googleProtobuf000.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.DeleteLogsResponse> {
    return this.$raw
      .deleteOldLogs(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
/**
 * Service client implementation for epicore.admin.SubscriptionEndpoint
 */
@Injectable({ providedIn: 'any' })
export class SubscriptionEndpointClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /epicore.admin.SubscriptionEndpoint/AddOrder
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.OrderDto>>
     */
    addOrder: (
      requestData: thisProto.AddOrderRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.OrderDto>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.SubscriptionEndpoint/AddOrder',
        requestData,
        requestMetadata,
        requestClass: thisProto.AddOrderRequest,
        responseClass: thisProto.OrderDto
      });
    },
    /**
     * Unary call: /epicore.admin.SubscriptionEndpoint/ToggleDisableOrder
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.OrderDto>>
     */
    toggleDisableOrder: (
      requestData: thisProto.ToggleDisableOrderRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.OrderDto>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.SubscriptionEndpoint/ToggleDisableOrder',
        requestData,
        requestMetadata,
        requestClass: thisProto.ToggleDisableOrderRequest,
        responseClass: thisProto.OrderDto
      });
    },
    /**
     * Unary call: /epicore.admin.SubscriptionEndpoint/GetUserOrders
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetUserOrdersResponse>>
     */
    getUserOrders: (
      requestData: thisProto.GetUserOrdersRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetUserOrdersResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.SubscriptionEndpoint/GetUserOrders',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetUserOrdersRequest,
        responseClass: thisProto.GetUserOrdersResponse
      });
    },
    /**
     * Unary call: /epicore.admin.SubscriptionEndpoint/CreateSubscription
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.SubscriptionResponse>>
     */
    createSubscription: (
      requestData: thisProto.CreateSubscriptionRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.SubscriptionResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.SubscriptionEndpoint/CreateSubscription',
        requestData,
        requestMetadata,
        requestClass: thisProto.CreateSubscriptionRequest,
        responseClass: thisProto.SubscriptionResponse
      });
    },
    /**
     * Unary call: /epicore.admin.SubscriptionEndpoint/UpdateSubscription
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.SubscriptionResponse>>
     */
    updateSubscription: (
      requestData: thisProto.UpdateSubscriptionRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.SubscriptionResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.SubscriptionEndpoint/UpdateSubscription',
        requestData,
        requestMetadata,
        requestClass: thisProto.UpdateSubscriptionRequest,
        responseClass: thisProto.SubscriptionResponse
      });
    },
    /**
     * Unary call: /epicore.admin.SubscriptionEndpoint/ToggleDisableSubscription
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.SubscriptionResponse>>
     */
    toggleDisableSubscription: (
      requestData: thisProto.DisableToggleRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.SubscriptionResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.SubscriptionEndpoint/ToggleDisableSubscription',
        requestData,
        requestMetadata,
        requestClass: thisProto.DisableToggleRequest,
        responseClass: thisProto.SubscriptionResponse
      });
    },
    /**
     * Unary call: /epicore.admin.SubscriptionEndpoint/CreateFeatureForSubscription
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.SubscriptionFullDetail>>
     */
    createFeatureForSubscription: (
      requestData: thisProto.CreateFeatureForSubscriptionRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.SubscriptionFullDetail>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/epicore.admin.SubscriptionEndpoint/CreateFeatureForSubscription',
        requestData,
        requestMetadata,
        requestClass: thisProto.CreateFeatureForSubscriptionRequest,
        responseClass: thisProto.SubscriptionFullDetail
      });
    },
    /**
     * Unary call: /epicore.admin.SubscriptionEndpoint/ToggleDisableSubscriptionFeature
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.SubscriptionFeatureDto>>
     */
    toggleDisableSubscriptionFeature: (
      requestData: thisProto.ToggleDisableSubscriptionFeatureRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.SubscriptionFeatureDto>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/epicore.admin.SubscriptionEndpoint/ToggleDisableSubscriptionFeature',
        requestData,
        requestMetadata,
        requestClass: thisProto.ToggleDisableSubscriptionFeatureRequest,
        responseClass: thisProto.SubscriptionFeatureDto
      });
    },
    /**
     * Unary call: /epicore.admin.SubscriptionEndpoint/GetForAddSubscriptionPrerequisites
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetForAddSubscriptionPrerequisitesResponse>>
     */
    getForAddSubscriptionPrerequisites: (
      requestData: googleProtobuf000.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<thisProto.GetForAddSubscriptionPrerequisitesResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/epicore.admin.SubscriptionEndpoint/GetForAddSubscriptionPrerequisites',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf000.Empty,
        responseClass: thisProto.GetForAddSubscriptionPrerequisitesResponse
      });
    },
    /**
     * Unary call: /epicore.admin.SubscriptionEndpoint/GetSubscriptions
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetSubscriptionsResponse>>
     */
    getSubscriptions: (
      requestData: googleProtobuf000.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetSubscriptionsResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.SubscriptionEndpoint/GetSubscriptions',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf000.Empty,
        responseClass: thisProto.GetSubscriptionsResponse
      });
    },
    /**
     * Unary call: /epicore.admin.SubscriptionEndpoint/GetSubscription
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.SubscriptionFullDetail>>
     */
    getSubscription: (
      requestData: thisProto.GetSubscriptionRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.SubscriptionFullDetail>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.SubscriptionEndpoint/GetSubscription',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetSubscriptionRequest,
        responseClass: thisProto.SubscriptionFullDetail
      });
    }
  };

  constructor(
    @Optional()
    @Inject(GRPC_SUBSCRIPTION_ENDPOINT_CLIENT_SETTINGS)
    settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'epicore.admin.SubscriptionEndpoint',
      settings
    );
  }

  /**
   * Unary call @/epicore.admin.SubscriptionEndpoint/AddOrder
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.OrderDto>
   */
  addOrder(
    requestData: thisProto.AddOrderRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.OrderDto> {
    return this.$raw
      .addOrder(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.SubscriptionEndpoint/ToggleDisableOrder
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.OrderDto>
   */
  toggleDisableOrder(
    requestData: thisProto.ToggleDisableOrderRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.OrderDto> {
    return this.$raw
      .toggleDisableOrder(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.SubscriptionEndpoint/GetUserOrders
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetUserOrdersResponse>
   */
  getUserOrders(
    requestData: thisProto.GetUserOrdersRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetUserOrdersResponse> {
    return this.$raw
      .getUserOrders(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.SubscriptionEndpoint/CreateSubscription
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.SubscriptionResponse>
   */
  createSubscription(
    requestData: thisProto.CreateSubscriptionRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.SubscriptionResponse> {
    return this.$raw
      .createSubscription(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.SubscriptionEndpoint/UpdateSubscription
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.SubscriptionResponse>
   */
  updateSubscription(
    requestData: thisProto.UpdateSubscriptionRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.SubscriptionResponse> {
    return this.$raw
      .updateSubscription(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.SubscriptionEndpoint/ToggleDisableSubscription
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.SubscriptionResponse>
   */
  toggleDisableSubscription(
    requestData: thisProto.DisableToggleRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.SubscriptionResponse> {
    return this.$raw
      .toggleDisableSubscription(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.SubscriptionEndpoint/CreateFeatureForSubscription
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.SubscriptionFullDetail>
   */
  createFeatureForSubscription(
    requestData: thisProto.CreateFeatureForSubscriptionRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.SubscriptionFullDetail> {
    return this.$raw
      .createFeatureForSubscription(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.SubscriptionEndpoint/ToggleDisableSubscriptionFeature
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.SubscriptionFeatureDto>
   */
  toggleDisableSubscriptionFeature(
    requestData: thisProto.ToggleDisableSubscriptionFeatureRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.SubscriptionFeatureDto> {
    return this.$raw
      .toggleDisableSubscriptionFeature(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.SubscriptionEndpoint/GetForAddSubscriptionPrerequisites
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetForAddSubscriptionPrerequisitesResponse>
   */
  getForAddSubscriptionPrerequisites(
    requestData: googleProtobuf000.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetForAddSubscriptionPrerequisitesResponse> {
    return this.$raw
      .getForAddSubscriptionPrerequisites(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.SubscriptionEndpoint/GetSubscriptions
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetSubscriptionsResponse>
   */
  getSubscriptions(
    requestData: googleProtobuf000.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetSubscriptionsResponse> {
    return this.$raw
      .getSubscriptions(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.SubscriptionEndpoint/GetSubscription
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.SubscriptionFullDetail>
   */
  getSubscription(
    requestData: thisProto.GetSubscriptionRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.SubscriptionFullDetail> {
    return this.$raw
      .getSubscription(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
/**
 * Service client implementation for epicore.admin.SmartChargeEndpoint
 */
@Injectable({ providedIn: 'any' })
export class SmartChargeEndpointClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /epicore.admin.SmartChargeEndpoint/GetActivityReportByUserId
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetUserReportResponse>>
     */
    getActivityReportByUserId: (
      requestData: thisProto.GetUserReportRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetUserReportResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.SmartChargeEndpoint/GetActivityReportByUserId',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetUserReportRequest,
        responseClass: thisProto.GetUserReportResponse
      });
    },
    /**
     * Unary call: /epicore.admin.SmartChargeEndpoint/GetTotalSaved
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetTotalSavedRequestResponse>>
     */
    getTotalSaved: (
      requestData: thisProto.GetTotalSavedRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetTotalSavedRequestResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.SmartChargeEndpoint/GetTotalSaved',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetTotalSavedRequest,
        responseClass: thisProto.GetTotalSavedRequestResponse
      });
    }
  };

  constructor(
    @Optional()
    @Inject(GRPC_SMART_CHARGE_ENDPOINT_CLIENT_SETTINGS)
    settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'epicore.admin.SmartChargeEndpoint',
      settings
    );
  }

  /**
   * Unary call @/epicore.admin.SmartChargeEndpoint/GetActivityReportByUserId
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetUserReportResponse>
   */
  getActivityReportByUserId(
    requestData: thisProto.GetUserReportRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetUserReportResponse> {
    return this.$raw
      .getActivityReportByUserId(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/epicore.admin.SmartChargeEndpoint/GetTotalSaved
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetTotalSavedRequestResponse>
   */
  getTotalSaved(
    requestData: thisProto.GetTotalSavedRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetTotalSavedRequestResponse> {
    return this.$raw
      .getTotalSaved(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
/**
 * Service client implementation for epicore.admin.AdminPowerPriceEndpoint
 */
@Injectable({ providedIn: 'any' })
export class AdminPowerPriceEndpointClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /epicore.admin.AdminPowerPriceEndpoint/GetElectricityPricesByUserId
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetElPricesByUserIdResponse>>
     */
    getElectricityPricesByUserId: (
      requestData: thisProto.GetElPricesByUserIdRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetElPricesByUserIdResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/epicore.admin.AdminPowerPriceEndpoint/GetElectricityPricesByUserId',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetElPricesByUserIdRequest,
        responseClass: thisProto.GetElPricesByUserIdResponse
      });
    }
  };

  constructor(
    @Optional()
    @Inject(GRPC_ADMIN_POWER_PRICE_ENDPOINT_CLIENT_SETTINGS)
    settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'epicore.admin.AdminPowerPriceEndpoint',
      settings
    );
  }

  /**
   * Unary call @/epicore.admin.AdminPowerPriceEndpoint/GetElectricityPricesByUserId
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetElPricesByUserIdResponse>
   */
  getElectricityPricesByUserId(
    requestData: thisProto.GetElPricesByUserIdRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetElPricesByUserIdResponse> {
    return this.$raw
      .getElectricityPricesByUserId(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
/**
 * Service client implementation for epicore.admin.ReportServiceEndpoint
 */
@Injectable({ providedIn: 'any' })
export class ReportServiceEndpointClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /epicore.admin.ReportServiceEndpoint/GetMainDashboardData
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetMainDashboardDataResponse>>
     */
    getMainDashboardData: (
      requestData: googleProtobuf000.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetMainDashboardDataResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/epicore.admin.ReportServiceEndpoint/GetMainDashboardData',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf000.Empty,
        responseClass: thisProto.GetMainDashboardDataResponse
      });
    }
  };

  constructor(
    @Optional()
    @Inject(GRPC_REPORT_SERVICE_ENDPOINT_CLIENT_SETTINGS)
    settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'epicore.admin.ReportServiceEndpoint',
      settings
    );
  }

  /**
   * Unary call @/epicore.admin.ReportServiceEndpoint/GetMainDashboardData
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetMainDashboardDataResponse>
   */
  getMainDashboardData(
    requestData: googleProtobuf000.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetMainDashboardDataResponse> {
    return this.$raw
      .getMainDashboardData(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
